import React, { useState } from 'react'

const Card = (props) => {

  const [modal, setModal] = useState(false)
  const toggleModal = () => {
      setModal(!modal)
  }

  return (
    <>
        <div className='content__box card__shadow'>
            <div className='box__img'>
                <img 
                    src={props.image}
                    onClick={toggleModal}/>
            </div>

            <div className='box__category'>
                <span 
                    onClick={toggleModal}>
                        {props.category}
                </span>
            </div>

            <div className='box__title'>
                <h2
                    onClick={toggleModal}>
                        {props.title}
                </h2>
                <a href='#popup' className='arrow'>
                    <i 
                    className='fas fa-arrow-right'
                    onClick={toggleModal}></i>
                </a>
            </div>         
        </div>

        {/* Popup box */}
      {modal && (
        <div className='modal'>
          <div onClick={toggleModal} className='overlay'></div>
          <div className='modal-content d_flex'>
            <div className='modal-img left'>
              <img src={props.image} alt='' />
            </div>
            <div className='modal-text right'>
              <span>{props.detail}</span>
              <h1>{props.title}</h1>
              <p>{props.description}</p>
              <div className='button'>
                <a href={props.github} target='_blank'><button className='btn_shadow'>
                  GITHUB <i className='fab fa-github'></i>
                </button></a>
                <a href={props.demo} target='_blank'><button className='btn_shadow'>
                  LIVE DEMO<i className='fas fa-chevron-right'></i>
                </button></a>
              </div>
              <button className='close-modal btn_shadow' onClick={toggleModal}>
                <i className='fas fa-times'></i>
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default Card